import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Utils } from '../../../../Utils/utils';
import { customValidator } from '../../../../Utils/validator';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../core/services/api.service';
import { FieldValue, ServiceName, SrIOName } from '../../../../shared/constants/services.enum';
import { SharedService } from '../../../../shared/services/shared.service';
import { Router } from '@angular/router';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { PaymentServiceRequest } from '../../../../shared/models/services-request/payment-service.model';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { CurrencyPipe } from '../../../../shared/pipes/currency.pipe';

@Component({
  selector: 'app-payment-service',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, CurrencyPipe],
  templateUrl: './payment-service.component.html',
  styleUrl: './payment-service.component.scss'
})
export class PaymentServiceComponent {
  @Input() isOpen = false;
  @Input() data: any = "";
  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() onBtnClick = new EventEmitter<any>();
  form: FormGroup;

  request: PaymentServiceRequest = new PaymentServiceRequest();
  lang: string = "en";
  userLoginName: string = "";
  userCSN: string = "";

  // This method is used to initialize the class instance using fb, api, shared service, and router
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private sharedService: SharedService,
    private router: Router,
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.userCSN = this.sharedService.getCsnAccountId('csn');

    this.form = this.fb.group({
      id: Utils.generateUniqueId(),
      amount: ['', [Validators.required, Validators.max(50000), customValidator('numberOnly')]],
    })
  }
  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {

  }
  srNumber: any = "";
  formSubmitLoader: boolean = false;
  // This method is used to submit request
  submitRequest() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    if(!this.userCSN){
      return;
    }
    let formData = this.form.value;
    this.formSubmitLoader = true;
    this.request.body.DCMethod = "SUBMIT";
    this.request.body.DCLoginName = this.userLoginName
    this.request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request'].CSN = this.userCSN;
    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request'].Amount = formData.amount;
    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request']["SR Type"] = ServiceName.PAYMENT_SERVICES;
    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request']["SR Sub Type"] = ServiceName.PAYMENT_ADVANCE_FOR_SERVICES;
    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request']["SR Sub Type"] = ServiceName.PAYMENT_ADVANCE_FOR_SERVICES;
    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request']['DC Channel'] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    this.request.body.DCIncomingHierarchy.ListOfDCCreatePaymntSRIO['Service Request']['DC Language'] = this.lang == 'ar' ? 'ARA' : 'ENU';

    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.CREATE_TOPUP_SR,
      this.request
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.formSubmitLoader = false;
        if (response['Error Code'] == null && response["SiebelMessage"]["Service Request"]) {
          this.srNumber = response["SiebelMessage"]["Service Request"]["SR Number"]; //response["DCSRNumber"];
          //set sr detail for success page to get ioname
           let lang: any = this.sharedService.getCurrentLang();
         
          const { service, serviceAr } = Utils.getServiceLabels(ServiceName.PAYMENT_ADVANCE_FOR_SERVICES, lang);
          let srDetailObj = {
            serviceSubTypeEn: service,
            serviceSubTypeAr: serviceAr,
            mainService: ServiceName.PAYMENT_SERVICES,
            service: ServiceName.PAYMENT_ADVANCE_FOR_SERVICES,
            IOName: SrIOName.CREATE_PAYMENT,
            srNumber: this.srNumber,
            totalSteps: 2,
            step: 1
          }
          this.onBtnClick.emit(formData);
          this.close();
          this.sharedService.setSrResponse(srDetailObj);
          this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
          if (response["SiebelMessage"]["Service Request"]["Status"] == SrStatus.ApprovedAndPaymentAwaited) {
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.PAYMENT + "/" + this.srNumber}`]);
          }
        } else {
          this.formSubmitLoader = false;
          this.sharedService.toastMessage('ERROR', '', 'error', response["errorCode"]);
        }

      }
    })

  }

  // This method is used to close
  close() {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }
}
